import type { FaireProductEntity } from "../../entity_types/product";

export const p_gqgbru8pf6: FaireProductEntity = {
  token: "p_gqgbru8pf6",
  type: "product",
  name: "LAVENDER BOTANICAL Canvas Tote Bags with Long Web Handles",
  brandToken: "b_gy33y47y5m",
  brandName: "Fashion City",
  imageUrl:
    "https://cdn.faire.com/fastly/38b307e098ca094b45d2b2211085c0d1a74788c033d5960a00564d7c20dc5a8d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0445c966cf3c56721a2d66cd23d0d66fca1aaf71c72c505babf7c218da9e522b.jpeg",
    "https://cdn.faire.com/fastly/2c39d60b36a90526b9bef068d0e414382fea91f8eb31045c88b09f12eaea0e8c.jpeg",
    "https://cdn.faire.com/fastly/858ccd63506e04b6674f44321dff6765ebdca3c008c37e3b6bacb1db17e3cf01.jpeg",
    "https://cdn.faire.com/fastly/e69a1433b6ab9471967933b58a3948b46eca20dc6f76d73be7f93a4a28f7071d.jpeg",
    "https://cdn.faire.com/fastly/4a2e4a6a9c9b48e3c6cc9ddfdb4708ebe25ecbd24720a65b2b94d5cde8f0061c.jpeg",
    "https://cdn.faire.com/fastly/38f98553be2bb21f5dc6dfe4ca305ac632f635c2622dbe2a011fb7c878ab2273.jpeg",
  ],
  priceDollars: 11.5,
  description:
    'LAVENDER BOTANICAL Canvas Tote Bags with Long Web Handles\n\n-LAVENDER BOTANICAL Graphic Print\n-Minimal Arched Typography Design\n-Heavy Canvas With Squared Bottom\n-Large Size For Grocery, Beach & Daily Use\n-Long Web Handles\n-Reinforced At Stress Points \n-100% Cotton \n\nSize: 20"W x 15"H x 5"D, Handles: 23"\n\nBold arched “Lavender” typography creates a clean botanical look with a fresh farm-inspired feel. The centered text layout paired with “Botanical,” “Farm Fresh Lavender,” and “Calm & Bloom” gives the design a simple, modern, and soothing aesthetic. This canvas tote bag is designed for everyday convenience with a roomy size, sturdy construction, and easy-to-carry long handles. Made from heavy material with reinforced stress points and a squared-off bottom for added support, it offers reliable durability for daily use. Perfect for shopping, errands, beach trips, picnics, travel, and more, this versatile tote combines practical function with a clean, stylish look that works for a wide range of designs and occasions.  ',
  tags: [],
  msrpDollars: 23,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:50.169Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
